import { object, string, number } from 'yup';
import * as yup from 'yup';

export const receiverTargetEnum = ["NO_ONE", "CONSUMER", "PASSENGER"];
export const reportsReceiverTargetEnum = ["NO_ONE", "CONSUMER"];

export const partnerCategoriesEnum = [
    'Hotels',
    'Bloggers',
    'Car Rentals',
    'Tour Operators',
    'YouTubers',
    'Travel Agencies',
    'Affiliate Marketers',
    'Event Organizers',
    'Local Experience Providers',
    'Travel Apps and Tech Companies',
    'Other'
]

const emailSettingsSchema = yup.object({
    partnerEmail: yup.string().email().optional(),
    receiverSettings: yup.object({
        bookingConfirmation: yup.mixed().oneOf(receiverTargetEnum).required(),
        bulkModification: yup.mixed().oneOf(receiverTargetEnum).required(),
        modificationRequest: yup.mixed().oneOf(receiverTargetEnum).required(),
        bookingError: yup.mixed().oneOf(receiverTargetEnum).required(),
        bookingRefund: yup.mixed().oneOf(receiverTargetEnum).required(),
        bookingPartialRefund: yup.mixed().oneOf(receiverTargetEnum).required(),
        tripCancellation: yup.mixed().oneOf(receiverTargetEnum).required(),
        bookingCurrentState: yup.mixed().oneOf(receiverTargetEnum).required(),
        cancellationReport: yup.mixed().oneOf(reportsReceiverTargetEnum).required(),
        bulkActionReport: yup.mixed().oneOf(reportsReceiverTargetEnum).required(),
    }).required(),
});

export const schema = object({

    emailSettings: emailSettingsSchema.required(),

    partnerType: yup.string().oneOf(['B2C', 'B2B']).required(),
    partnerCategory: yup.string().oneOf(partnerCategoriesEnum).optional(),
    cancellationsEnabled: yup.boolean().required(),
    modificationsEnabled: yup.boolean().required(),
    openTicketsEnabled: yup.boolean().required(),
    hasAccessToBookings: yup.boolean().required(),

    name: string()
        .min(3)
        .max(50)
        .required(),

    password: string()
        .min(8)
        .max(50)
        .required(),

    contactEmail: string()
        .email()
        .required(),

    masterCode: string()
        .min(5)
        .max(500)
        .required(),

    fixedCommission: number()
        .required(),

    feeCommission: number()
        .required(),

    affiliationModel: string()
        .required(),

    color: string(),
});